import { Stack } from '@mui/system';
import React, { useEffect } from 'react';
import { GeneralErrorUI } from '../../components/errors/generalError';
import { useMonitoring } from '../../contexts';

interface Props {
  title?: string;
  description?: string;
  hasHomeButton?: boolean;
  hasReloadButton?: boolean;
  imageComponent?: React.JSX.Element;
}

export function ErrorPage({
  title,
  description,
  imageComponent,
  hasHomeButton,
  hasReloadButton,
}: Props) {
  const monitoring = useMonitoring();

  useEffect(() => {
    monitoring.reportErrors();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Stack height='100%' component='div' data-testid='error-page'>
      <GeneralErrorUI
        title={title}
        description={description}
        imageComponent={imageComponent}
        hasHomeButton={hasHomeButton}
        hasReloadButton={hasReloadButton}
      />
    </Stack>
  );
}
